import React from 'react';
import { Route } from 'react-router-dom';
import loadable from '@loadable/component';
import { Loadable } from 'components/Loadable';
import constants from 'Constants';
import * as paths from 'Paths';


const OverviewRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reviews/overview" */
    'routes/Extensions/Reviews/OverviewRoute'
  )
));

const AnalyticsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reviews/analytics" */
    'routes/Extensions/Reviews/AnalyticsRoute'
  )
));

const UpdateConfigRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reviews/update-config" */
    'routes/Extensions/Reviews/UpdateConfigRoute'
  )
));

const ConnectionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reviews/connections" */
    'routes/Extensions/Reviews/ConnectionsRoute'
  )
));

const ReviewsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reviews/index" */
    'routes/Extensions/Reviews/ReviewsRoute'
  )
));

const BigCommerceReviewsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reviews/bigcommerce" */
    'routes/Extensions/Reviews/BigCommerceReviewsRoute'
  )
));

const WidgetsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reviews/widgets" */
    'routes/Extensions/Reviews/WidgetsRoute'
  )
));

const StarRatingsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reviews/star-ratings" */
    'routes/Extensions/Reviews/StarRatingsRoute'
  )
));

const CollectorsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reviews/collectors" */
    'routes/Extensions/Reviews/CollectorsRoute'
  )
));

const UpdateCollectorRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reviews/update-collector" */
    'routes/Extensions/Reviews/UpdateCollectorRoute'
  )
));

const UpdateWidgetRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reviews/update-widget" */
    'routes/Extensions/Reviews/UpdateWidgetRoute'
  )
));

const UpdateStarRatingRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reviews/update-star-rating" */
    'routes/Extensions/Reviews/UpdateStarRatingRoute'
  )
));

const UpdateEmailsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reviews/update-emails" */
    'routes/Extensions/Reviews/UpdateEmailsRoute'
  )
));

const EmailsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reviews/emails" */
    'routes/Extensions/Reviews/EmailsRoute'
  )
));

const EmailRecipientsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reviews/email-recipients" */
    'routes/Extensions/Reviews/EmailRecipientsRoute'
  )
));

const EmailAnalyticsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reviews/email-analytics" */
    'routes/Extensions/Reviews/EmailAnalyticsRoute'
  )
));

const EmailConversionsRoute = Loadable(loadable(
  () => import(
    /* webpackChunkName: "console/reviews/email-conversions" */
    'routes/Extensions/Reviews/EmailConversionsRoute'
  )
));


const getReviewsRoutes = () => {
  return [
    {path: paths.getPathReviewsOverview(), component: OverviewRoute},
    {path: paths.getPathReviewsAnalytics(), component: AnalyticsRoute},
    {path: paths.getPathAddReviewsConfig(), render: (props) => <UpdateConfigRoute {...props} isCreate={true} />},
    {path: paths.getPathEditReviewsConfig(), render: (props) => <UpdateConfigRoute {...props} isCreate={false} />},

    {path: paths.getPathReviewsConnections(), component: ConnectionsRoute},

    {path: paths.getPathProductReviews(), render: (props) => <ReviewsRoute {...props} entity={constants.REVIEWS_ENTITY_PRODUCT} />},
    {path: paths.getPathSiteReviews(), render: (props) => <ReviewsRoute {...props} entity={constants.REVIEWS_ENTITY_SITE} />},
    {path: paths.getPathBigCommerceReviews(), component: BigCommerceReviewsRoute},

    {path: paths.getPathReviewsCollectors(), component: CollectorsRoute},
    {path: paths.getPathReviewsWidgets(), component: WidgetsRoute},
    {path: paths.getPathStarRatings(), component: StarRatingsRoute},

    {path: paths.getPathAddReviewsCollector(), component: UpdateCollectorRoute},
    {path: paths.getPathEditReviewsCollector(":collectorId"), component: UpdateCollectorRoute},
    {path: paths.getPathReplicateReviewsCollector(":collectorId"), render: (props) => <UpdateCollectorRoute {...props} isReplicate={true} />},

    {path: paths.getPathAddReviewsWidget(), component: UpdateWidgetRoute},
    {path: paths.getPathEditReviewsWidget(":widgetId"), component: UpdateWidgetRoute},
    {path: paths.getPathReplicateReviewsWidget(":widgetId"), render: (props) => <UpdateWidgetRoute {...props} isReplicate={true} />},

    {path: paths.getPathAddStarRating(), component: UpdateStarRatingRoute},
    {path: paths.getPathEditStarRating(":starRatingId"), component: UpdateStarRatingRoute},
    {path: paths.getPathReplicateStarRating(":starRatingId"), render: (props) => <UpdateStarRatingRoute {...props} isReplicate={true} />},

    {path: paths.getPathEditReviewsEmails(), component: UpdateEmailsRoute},
    {path: paths.getPathReviewsEmails(), component: EmailsRoute},
    {path: paths.getPathReviewsEmailRecipients(":emailId"), component: EmailRecipientsRoute},
    {path: paths.getPathReviewsEmailAnalytics(":emailId"), component: EmailAnalyticsRoute},
    {path: paths.getPathReviewsEmailConversions(":emailId"), component: EmailConversionsRoute},
  ]
}


export { getReviewsRoutes };
